import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-16 flex items-center justify-between">
        <a
          href="#top"
          className={`flex items-center gap-2 font-heading text-lg font-semibold whitespace-nowrap transition-colors ${
            solid ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <span
            className={`w-8 h-8 flex items-center justify-center rounded-md ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/20 text-background-50"
            }`}
          >
            <i className="ri-book-2-line"></i>
          </span>
          漂亮的小姨子
          <span className={`hidden sm:inline text-sm font-normal ${solid ? "text-foreground-600" : "text-background-100"}`}>
            · 衍生内容整理
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                solid
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-background-50/15"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl transition-colors ${
            solid ? "text-foreground-950 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
          }`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2 text-sm rounded-md text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}